'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-visor';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e04c';
var svgPathData = ['M114 176l220 0c-18.5 42.4-60.8 72-110 72s-91.5-29.6-110-72zM134.6 48c22-24.5 53.9-40 89.4-40s67.5 15.5 89.4 40L134.6 48zm142 407l35.1-70.3c3.4-6.9 13.3-6.9 16.7 0L363.5 455c4 8-4.5 16.5-12.5 12.5l-26.8-13.4c-2.6-1.3-5.7-1.3-8.3 0L289 467.5c-8 4-16.5-4.5-12.5-12.5z', 'M112 48C94.3 48 80 62.3 80 80l0 64c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L112 48zm82.3 256C95.8 304 16 383.8 16 482.3 16 498.7 29.3 512 45.7 512l356.6 0c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3l-59.4 0zM132 112c0-11 9-20 20-20l144 0c11 0 20 9 20 20s-9 20-20 20l-144 0c-11 0-20-9-20-20zM311.7 384.7c3.4-6.9 13.3-6.9 16.7 0L363.5 455c4 8-4.5 16.5-12.5 12.5l-26.8-13.4c-2.6-1.3-5.7-1.3-8.3 0L289 467.5c-8 4-16.5-4.5-12.5-12.5l35.1-70.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserVisor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;